import React from 'react';
import { Link } from 'react-router-dom';
import { Menu } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { EUserLevels, EUserRoles, IUser } from '@relab/alstom-ptw-shared';

import { appState, routerStateLocation } from '../redux/selectors';
import { RootState } from '../redux/types';
import { TranslationComponent } from './TranslationComponent';

interface NavBarProps {
  currentPath: string;
  user: IUser;
}

const PNavBar = ({ currentPath, user }: NavBarProps) => (
  <Menu pointing secondary>
    {user.userRoles.includes(EUserRoles.Ptw) && (
      <Menu.Item active={currentPath.includes('/projects')}>
        <Link to="/projects">
          <TranslationComponent stringKey={'PTW PROJECTS'} />
        </Link>
      </Menu.Item>
    )}
    {(user.userRoles.includes(EUserRoles.EhsManager) ||
      user.userRoles.includes(EUserRoles.EhsApplicant) ||
      user.userRoles.includes(EUserRoles.EhsMaintenanceManager) ||
      user.userRoles.includes(EUserRoles.EhsMaintenanceBasic) ||
      user.userRoles.includes(EUserRoles.EhsMaintenanceExternalCompany) ||
      user.userRoles.includes(EUserRoles.EhsMaintenanceExternalCompanyPlus)) && (
      <Menu.Item active={currentPath.includes('/ehss')}>
        <Link to="/ehss">
          <TranslationComponent stringKey={'EHS'} />
        </Link>
      </Menu.Item>
    )}
    {user.userLevel === EUserLevels.Admin && (
      <Menu.Item active={currentPath === '/users'}>
        <Link to="/users">
          <TranslationComponent stringKey={'USERS'} />
        </Link>
      </Menu.Item>
    )}
    {user.userLevel === EUserLevels.Admin && (
      <Menu.Item active={currentPath === '/workstations'}>
        <Link to="/workstations">
          <TranslationComponent stringKey={'WORKSTATIONS'} />
        </Link>
      </Menu.Item>
    )}
    {user.userLevel === EUserLevels.Admin && (
      <Menu.Item active={currentPath === '/buildings'}>
        <Link to="/buildings">
          <TranslationComponent stringKey={'BUILDINGS'} />
        </Link>
      </Menu.Item>
    )}{' '}
  </Menu>
);

const mapStateToProps = (state: RootState) => ({
  currentPath: routerStateLocation(state).pathname,
  user: appState(state).user,
});

export const NavBar = connect(mapStateToProps)(PNavBar);
